<!--
底部按钮

使用说明：

<BottomAction
    :text=""
    :link=""
 />

-->
<template>
    <div class="actions">
        <a href="javascript:;" class="action-btn" @click="goto">{{text}}</a>
    </div>
</template>

<script>
import store from '../../api/store'

export default {
  props: ['text', 'link'],
  data(){
    return {
        
    }
  },
  watch:{
      
  },
  methods: {
    goto(){
        if(this.link.startsWith('http')){
            window.location.href=this.link;
        }else{
            this.$routerPush(this, this.link);
        }
    }
  }
}
</script>

<style scoped lang="less">
.actions{
    background: #fff;
    text-align: center;
    padding: 3.33vw;
    .action-btn{
        display: inline-block;
        color: #ff0129;
        font-size: 3.86vw;
        line-height: 6.6vw;
        padding: 0 4vw;
        border: .266vw solid #ff0129;
        border-radius: 4vw;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/common/BottomAction.vue